import { useState, useEffect } from "react";
import { GetMocktestQuestion } from "../../../Client/request";

export const useListeningQuestion = (quest, startStopwatch, cachedQuestionData = null) => {
  const [questData, setQuestData] = useState(cachedQuestionData || null);
  const [loading, setLoading] = useState(!cachedQuestionData);

  useEffect(() => {
    if (quest) {
      setLoading(true);
      if (cachedQuestionData) {
        setQuestData(cachedQuestionData);
        setLoading(false);
        startStopwatch();
        return;
      }

      GetMocktestQuestion(quest.QuestionId).then((res) => {
        if (res.data) {
          setQuestData(res.data);
          setLoading(false);
          startStopwatch();
        }
      });
    }
    // eslint-disable-next-line
  }, [quest, cachedQuestionData]); // startStopwatch intentionally omitted to prevent re-renders

  return {
    questData,
    loading,
    setQuestData,
  };
};
